import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ExportDirective } from './directives/export.directive';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IconsProviderModule } from './icons-provider.module';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { CookieService } from 'ngx-cookie-service';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzCommentModule } from 'ng-zorro-antd/comment';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzBackTopModule } from 'ng-zorro-antd/back-top';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTreeModule } from 'ng-zorro-antd/tree';

import { FormsComponent } from './pages/CommonModule/Forms/forms/forms.component'
import { FormComponent } from './pages/CommonModule/Forms/form/form.component'
import { RolesComponent } from './pages/CommonModule/Roles/roles/roles.component'
import { RoleComponent } from './pages/CommonModule/Roles/role/role.component'
import { RoledetailsComponent } from './pages/CommonModule/Roles/roledetails/roledetails.component'
import { UsersComponent } from './pages/CommonModule/Users/users/users.component'
import { UserComponent } from './pages/CommonModule/Users/user/user.component'
import { LoginComponent } from './login/login.component'

import { AdmindashboardComponent } from './pages/CommonModule/admindashboard/admindashboard.component';
import { AngularEditorModule } from '@kolkov/angular-editor';

import { ClientMasterComponent } from '../app/pages/BasicForms/ClientM/client-master/client-master.component';
import { ClientDrawerComponent } from './pages/BasicForms/ClientM/client-drawer/client-drawer.component';

import { ProjectMasterComponent } from './pages/BasicForms/ProjectM/project-master/project-master.component';
import { ProjectDrawerComponent } from './pages/BasicForms/ProjectM/project-drawer/project-drawer.component';
import { ProjectMappingComponent } from './pages/BasicForms/ProjectM/project-mapping/project-mapping.component';

import { ModuleMasterComponent } from './pages/BasicForms/ModuleM/module-master/module-master.component';
import { ModuleDrawerComponent } from './pages/BasicForms/ModuleM/module-drawer/module-drawer.component';
import { ModuleMappingComponent } from './pages/BasicForms/ModuleM/module-mapping/module-mapping.component';

import { FeatureMasterComponent } from './pages/BasicForms/Feature/feature-master/feature-master.component';
import { FeatureDrawerComponent } from './pages/BasicForms/Feature/feature-drawer/feature-drawer.component';
import { FeatureMappingComponent } from './pages/BasicForms/Feature/feature-mapping/feature-mapping.component';

import { CategoryMasterComponent } from './pages/BasicForms/Category/category-master/category-master.component';
import { CategoryDrawerComponent } from './pages/BasicForms/Category/category-drawer/category-drawer.component';

import { TaskMasterComponent } from './pages/BasicForms/TaskM/task-master/task-master.component';
import { TaskDrawerComponent } from './pages/BasicForms/TaskM/task-drawer/task-drawer.component';
import { TaskSubtaskMappingComponent } from './pages/BasicForms/TaskM/task-subtask-mapping/task-subtask-mapping.component';

import { AttachmentMasterComponent } from '../app/pages/BasicForms/AttachmentM/attachment-master/attachment-master.component';
import { AttachmentDrawerComponent } from '../app/pages/BasicForms/AttachmentM/attachment-drawer/attachment-drawer.component';

import { WorklogComponent } from '../app/pages/BasicForms/workLog/worklog/worklog.component';
import { WorklogDrawerComponent } from './pages/BasicForms/workLog/worklog-drawer/worklog-drawer.component';

import { AssigneeMappingComponent } from './pages/BasicForms/assignee-mapping/assignee-mapping.component';

import { CommentComponent } from '../app/pages/BasicForms/Comment/comment/comment.component';
import { CommentDrawerComponent } from '../app/pages/BasicForms/Comment/comment-drawer/comment-drawer.component';

import { TaskTransferHistoryComponent } from '../app/pages/BasicForms/taskTransfer/task-transfer-history/task-transfer-history.component';
import { TaskTransferDrawerComponent } from '../app/pages/BasicForms/taskTransfer/task-transfer-drawer/task-transfer-drawer.component';

import { TypeMasterComponent } from '../app/pages/BasicForms/Type/type-master/type-master.component';
import { TypeDrawerComponent } from '../app/pages/BasicForms/Type/type-drawer/type-drawer.component';

import { ModuleFeatureViewComponent } from '../app/pages/BasicForms/ModuleFeatureView/module-feature-view/module-feature-view.component';
import { FeatureViewComponent } from '../app/pages/BasicForms/ModuleFeatureView/feature-view/feature-view.component';

import { KanbanComponent } from '../app/pages/BasicForms/Kanban/kanban/kanban.component';
import { KanbanProjectWiseComponent } from '../app/pages/BasicForms/Kanban/kanban-project-wise/kanban-project-wise.component';

import { RoadmapComponent } from '../app/pages/BasicForms/roadmap/roadmap.component';

import { ToolbarService, TreeGridModule } from '@syncfusion/ej2-angular-treegrid';
import { PageService, SortService, FilterService } from '@syncfusion/ej2-angular-treegrid';

import { EmployeeHoursReportComponent } from '../app/pages/Reports/employee-hours-report/employee-hours-report.component';
import { EmployeeProjectWiseComponent } from '../app/pages/Reports/employee-project-wise/employee-project-wise.component';
import { ProjectWiseWorkingHoursComponent } from '../app/pages/Reports/project-wise-working-hours/project-wise-working-hours.component';
import { ProjectWiseDetailsComponent } from '../app/pages/Reports/project-wise-details/project-wise-details.component';
import { ProjectWiseSummaryComponent } from '../app/pages/Reports/project-wise-summary/project-wise-summary.component';
import { UserWiseDetailedComponent } from '../app/pages/Reports/user-wise-detailed/user-wise-detailed.component';
import { UserWiseDetailedWithoutTaskSubtaskComponent } from '../app/pages/Reports/user-wise-detailed-without-task-subtask/user-wise-detailed-without-task-subtask.component';
import { EfficiencyComponent } from '../app/pages/Reports/efficiency/efficiency.component';
import { ProjectWiseEmployeeDetailsComponent } from '../app/pages/Reports/project-wise-employee-details/project-wise-employee-details.component';
import { DetaildWorklogReportComponent } from '../app/pages/Reports/detaild-worklog-report/detaild-worklog-report.component';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { SecondToHoursPipe } from '../app/pipes/second-to-hours.pipe';
import { AddtaskComponent } from './pages/BasicForms/DailySchedule/addtask/addtask.component';
import { SchedulelistComponent } from './pages/BasicForms/DailySchedule/schedulelist/schedulelist.component'; 
import { PmsgiantreportComponent } from './Reports/pmsgiantreport/pmsgiantreport.component'; 
import { AddPmsWorkLogComponent } from './pages/BasicForms/PmsWorkLog/add-pms-work-log/add-pms-work-log.component';
import { ViewPmsWorkLogComponent } from './pages/BasicForms/PmsWorkLog/view-pms-work-log/view-pms-work-log.component';
import { DateAgoPipe } from './pipes/date-ago.pipe';
import { EvaluationReportComponent } from './pages/Reports/evaluation-report/evaluation-report.component';
import { EmployeeTimeUtilizationReportComponent } from './pages/Reports/employee-time-utilization-report/employee-time-utilization-report.component';
import { BillReportComponent } from './pages/Reports/billReport/bill-report/bill-report.component';
import { ProjectDetailsMasterComponent } from './pages/CommonModule/project-master/project-master.component';
import { MonthlyBillingComponent } from './pages/Reports/monthly-billing/monthly-billing.component';
import { EmployeePhaseTimeCompensationReportComponent } from './pages/Reports/employee-phase-time-compensation-report/employee-phase-time-compensation-report.component';
import { UserListComponentComponent } from './pages/CommonModule/user-list-component/user-list-component.component';
import { MonthlyBillingGetPreviewComponent } from './pages/Reports/monthly-billing-get-preview/monthly-billing-get-preview.component';



registerLocaleData(en);

@NgModule({
  declarations: [

    EvaluationReportComponent ,
    EmployeeTimeUtilizationReportComponent ,
    BillReportComponent ,
    ProjectDetailsMasterComponent ,
    MonthlyBillingComponent ,
    EmployeePhaseTimeCompensationReportComponent ,
  
    AppComponent,
    ExportDirective,
    FormsComponent,
    FormComponent,
    RolesComponent,
    RoleComponent,
    RoledetailsComponent,
    UsersComponent,
    UserComponent,
    LoginComponent,
    AdmindashboardComponent,

    ClientMasterComponent,
    ClientDrawerComponent,

    ProjectMasterComponent,
    ProjectDrawerComponent,
    ProjectMappingComponent,

    ModuleMasterComponent,
    ModuleDrawerComponent,
    ModuleMappingComponent,

    FeatureMasterComponent,
    FeatureDrawerComponent,
    FeatureMappingComponent,

    ModuleFeatureViewComponent,
    FeatureViewComponent,

    CategoryMasterComponent,
    CategoryDrawerComponent,

    TaskMasterComponent,
    TaskDrawerComponent,
    TaskSubtaskMappingComponent,

    TaskTransferHistoryComponent,
    TaskTransferDrawerComponent,

    AttachmentMasterComponent,
    AttachmentDrawerComponent,

    WorklogComponent,
    WorklogDrawerComponent,

    AssigneeMappingComponent,

    CommentComponent,
    CommentDrawerComponent,

    TypeMasterComponent,
    TypeDrawerComponent,

    KanbanComponent,
    KanbanProjectWiseComponent,
    RoadmapComponent,

    EmployeeHoursReportComponent,
    EmployeeProjectWiseComponent,
    ProjectWiseWorkingHoursComponent,
    ProjectWiseDetailsComponent,
    ProjectWiseSummaryComponent,
    UserWiseDetailedComponent,
    UserWiseDetailedWithoutTaskSubtaskComponent,
    EfficiencyComponent,
    ProjectWiseEmployeeDetailsComponent,
    DetaildWorklogReportComponent,
    AddtaskComponent,
    SchedulelistComponent,
    SecondToHoursPipe,
    PmsgiantreportComponent,
    AddPmsWorkLogComponent,
    ViewPmsWorkLogComponent,
    DateAgoPipe,
    UserListComponentComponent,
    MonthlyBillingGetPreviewComponent
  ],

  imports: [
    BrowserModule,
    NzEmptyModule,
    AngularEditorModule,
    AppRoutingModule,
    IconsProviderModule,
    NzLayoutModule,
    NzMenuModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NzFormModule,
    NzInputModule,
    NzTableModule,
    NzDrawerModule,
    NzSpinModule,
    NzSelectModule,
    NzDropDownModule,
    NzIconModule,
    NzNotificationModule,
    NzButtonModule,
    Ng2SearchPipeModule,
    NzSwitchModule,
    NzInputNumberModule,
    NzDatePickerModule,
    NzTreeSelectModule,
    NzRadioModule,
    NzDividerModule,
    NzTagModule,
    NzModalModule,
    NzPopoverModule,
    NzCheckboxModule,
    NgApexchartsModule,
    NzMessageModule,
    NzBadgeModule,
    NzStepsModule,
    NzCardModule,
    NzCommentModule,
    NzListModule,
    NzToolTipModule,
    NzAutocompleteModule,
    NzTimePickerModule,
    NgIdleKeepaliveModule.forRoot(),
    NzProgressModule,
    NzPopconfirmModule,
    NzBackTopModule,
    NzAvatarModule,
    NzTypographyModule,
    NzTabsModule,
    NzTreeModule,
    TreeGridModule,
    NzTimelineModule,


  ],

  providers: [{ provide: NZ_I18N, useValue: en_US }, CookieService, PageService, SortService, FilterService, ToolbarService],
  bootstrap: [AppComponent]
})

export class AppModule { }
